import Drawer from "@components/shared/Drawer";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import WarehouseFilterForm from "./WarehouseFilterForm";

function WarehouseTableFilterDrawer({
  open,
  onClose,
  defaultValue,
  onFilter,
}: any) {
  const { t } = useTranslation();

  const filterForm = useFormik({
    initialValues: defaultValue,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values) => {
      onFilter && onFilter(values);
      onClose();
    },
  });

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={t("filter")}
      onSave={() => filterForm.handleSubmit()}
      size="large"
    >
      <WarehouseFilterForm form={filterForm} />
    </Drawer>
  );
}

export default WarehouseTableFilterDrawer;
